import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { App as AppAntD } from 'antd';
import store from './store';
import history from './history';
import Layouts from './layouts';
import { THEME_CONFIG } from './configs/AppConfig';
import { IntlProvider } from 'react-intl';
import AppLocale from 'lang/intl';
import './lang';
import './index.css';


function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter history={history}>
          <IntlProvider locale={AppLocale[THEME_CONFIG.locale].locale} messages={AppLocale[THEME_CONFIG.locale].messages}>
            <AppAntD>
              <Layouts />
            </AppAntD>
          </IntlProvider>
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
